export const maxWidthContent = 1300;

export const layoutStyle = {
    minHeight: '100vh',
};

export const layoutContentStyle = {
    margin: '0 auto',
};
